import { useNewAccessGroupModal } from "@circle-react/components/SettingsApp/AccessGroups/NewAccessGroupModal";
import { useAccessGroups } from "@circle-react/hooks/accessRegistry/useAccessGroups";
import type { AccessGroupType } from "@circle-react/types/AccessGroup";
import { useEditAccessGroupModal } from "../EditAccessGroupModal";

interface UseOpenNewAccessGroupModalProps {
  selectNewAccessGroup?: (accessGroup: AccessGroupType) => void;
}

export const useOpenNewAccessGroupModal = ({
  selectNewAccessGroup,
}: UseOpenNewAccessGroupModalProps = {}) => {
  const { refetch: refetchAccessGroups } = useAccessGroups();
  const editAccessGroupModal = useEditAccessGroupModal();
  const newAccessGroupModal = useNewAccessGroupModal();

  const reloadAccessGroups = async () => {
    await refetchAccessGroups();
  };

  const editAccessGroup = (accessGroup: AccessGroupType) => {
    void editAccessGroupModal.show({ accessGroup });
  };

  const onSuccessNewAccessGroup = async (accessGroup: AccessGroupType) => {
    await reloadAccessGroups();
    selectNewAccessGroup?.(accessGroup);
    editAccessGroup(accessGroup);
  };

  const openNewAccessGroupModal = (name?: string, description?: string) => {
    void newAccessGroupModal.show({
      accessGroupName: name,
      accessGroupDescription: description,
      onSuccess: onSuccessNewAccessGroup,
    });
  };

  return { openNewAccessGroupModal };
};
